import { Link, Outlet } from "react-router";
import { Logo } from "@/components/shared/logo";

// Shared shell for /login, /forgot-password, /reset-password, /invite/:token.
// Ports /app/(auth)/layout.tsx — same radial-gradient backdrop, same centered
// 420px card target, same header. next/link swapped for react-router Link.
export function AuthLayout() {
  return (
    <div className="relative min-h-screen overflow-hidden bg-background">
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 opacity-[0.35]"
        style={{
          background:
            "radial-gradient(60% 50% at 50% 0%, hsl(var(--brand-teal) / 0.16), transparent 60%)",
        }}
      />
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 opacity-[0.25]"
        style={{
          background:
            "radial-gradient(50% 50% at 100% 100%, hsl(var(--brand-ink) / 0.10), transparent 60%)",
        }}
      />

      <header className="relative z-10 flex h-16 items-center justify-between px-8">
        <Link to="/" className="flex items-center gap-2">
          <Logo />
          <span className="text-sm text-muted-foreground">by Bookboost</span>
        </Link>
        <a
          href="https://bookboost.io"
          target="_blank"
          rel="noreferrer noopener"
          className="text-xs text-muted-foreground hover:text-foreground"
        >
          bookboost.io →
        </a>
      </header>

      <main className="relative z-10 flex min-h-[calc(100vh-4rem)] items-center justify-center px-6 pb-16">
        <div className="w-full max-w-[420px] animate-fade-up">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
